import {Model} from "ords/dist/model/model";

export class Assignment extends Model {

    isPublished() {
        return this.publishings.length;
    }

    hasDeadline() {
        return !!this.deadlines.length;
    }

    getDeadline() {
        if (!this.hasDeadline()) {
            return null
        }
        return this.deadlines[0];
    }

    hasStatus() {
        return !!this.statuses.length;
    }

    getStatus() {
        if (!this.hasStatus()) {
            return null
        }
        return this.statuses[0];
    }

    hasPartWithTypeAssignment() {
        for (const subAssignment of this.sub_assignments) {
            if (subAssignment.hasPartWithTypeAssignment()) {
                return true;
            }
        }
        return false;
    }

    hasSubAssignmentWithAssignmentCooperation() {
        for (const subAssignment of this.sub_assignments) {
            if (subAssignment.hasAssignmentCooperation()) {
                return true;
            }
        }
        return false;
    }

    hasAssignmentCooperation() {
        return !!this.assignment_cooperations.length
    }

    hasFeedback() {
        return !!this.feedback.length;
    }

    getAssignmentCooperation() {
        return this.hasAssignmentCooperation
            ? this.assignment_cooperations[0]
            : [];
    }

}

export const AssignmentModelConfig = {
    name: 'assignment',
    model: Assignment,
    relations: [
        {name: 'publishings', model_name: 'assignmentPublishing', type: 'hasMany'},
        {name: 'deadlines', model_name: 'assignmentDeadline', type: 'hasMany'},
        {name: 'sub_assignments', model_name: 'subAssignment', type: 'hasMany'},
        {name: 'statuses', model_name: 'assignmentStatus', type: 'hasMany'},
        {name: 'portfolio_rating', model_name: 'portfolioRating', type: 'hasOne'},
        {name: 'feedback', model_name: 'assignmentFeedback', type: 'hasMany'},
        {name: 'assignment_cooperations', model_name: 'assignmentCooperation', type: 'hasMany'},
        // {name: 'assignment_partners', model_name: 'assignmentPartner', type: 'hasMany'},
        {name: 'profileimage', model_name: 'assignmentProfileImage', type: 'hasOne'},
    ]
}
